import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/contabilidad/clasificaciones-objeto-gasto';
export const baseURIInterno = 'contabilidad/clasificaciones-objeto-gasto-interno';

/**
 * GET Clasificadores Objeto Gasto
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getClasificadoresObjetosGasto = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Clasificadores Objeto Gasto interno
 * @oaram {object} params
 * @returns {<Promise[]>}
 */
export const getCOGInternos = async (params) => {
  try {
    const response = await API.get(baseURIInterno, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Clasificador Objeto Gasto
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getClasificadorObjetoGasto = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Clasificador Objeto Gasto
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClasificadorObjetoGasto = async (values) => {
  try {
    const response = await API.post(baseURIInterno, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Clasificador Objeto Gasto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClasificadorObjetoGasto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURIInterno}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Clasificador Objeto Gasto
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteClasificadorObjetoGasto = async (id) => {
  try {
    const response = await API.delete(`${baseURIInterno}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
